import React from "react";
import useLogin from "./useLogin";
import AuthInput from "../../Components/AuthInput";
import OTPInput from "../../Components/OTPInput";

export default function LoginModal({ open, onClose }) {
  const {
    register,
    handleSubmit,
    onSubmit,
    signupHandleSubmit,
    signupRegister,
    onSignup,
    setFormType,
    formType,
    signupErrors,
    errors,
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    onResendOtp,
    onSkip
  } = useLogin({ isModal: true, onClose });

  if (!open) return null;

  return (
    <div
      // onClick={onClose}
      className="modal bg-black/80 h-screen fixed left-0 flex justify-center items-center top-0 w-full z-40 px-6 py-3 md:px-10"
    >
      <div
        className="bg-blueGray p-6 px-4 md:px-8 rounded-md max-w-lg w-full my-auto md:mx-auto border border-borderGray"
        onClick={e => e.stopPropagation()}
      >
        <div className="w-full text-center mb-6">
          <div className="inline-flex border border-borderGray rounded overflow-hidden">
            <button
              className={`px-6 py-2 text-sm font-medium transition ${
                formType === "login" ? "bg-secondary text-white" : "bg-[#384355] text-gray-300 hover:text-white"
              }`}
              onClick={() => setFormType("login")}
            >
              Login
            </button>
            <button
              className={`px-6 py-2 text-sm font-medium transition ${
                formType === "signup" ? "bg-secondary text-white" : "bg-[#384355] text-gray-300 hover:text-white"
              }`}
              onClick={() => setFormType("signup")}
            >
              Sign Up
            </button>
          </div>
        </div>

        {/* OTP Form */}
        {showOtpForm ? 
        (
                  <form onSubmit={onOtpSubmit} className="bg-transparent p-12 py-12 rounded text-white">
                    <h1 className="mb-3 text-2xl font-bold text-center text-white">Verify OTP</h1>
                     <p className="text-xl text-center text-gray-300 mb-6">
                    A verification code has been sent to <strong className="text-white">{"email"}</strong>
                  </p>
                    <OTPInput value={otp} onChange={setOtp} length={6} disabled={resendLoading} />
                    {otpError && <div className="text-red-500 mb-2">{otpError}</div>}
                    {otpSuccess && <div className="text-green-600 mb-2">{otpSuccess}</div>}
                  <div className='w-full justify-center items-center flex flex-col'>
                       <button
                      type="submit"
                      className="uppercase w-full mt-12 p-3 rounded-md bg-secondary hover:bg-secondary/75 text-white"
                      disabled={otp.length !== 6}
                    >
                      Verify OTP
                    </button>
                    <button
                      type="button"
                      onClick={onResendOtp}
                      className="w-full mt-3 p-2 rounded-md bg-[#384355] text-secondary hover:bg-[#4A5567] border border-borderGray"
                      disabled={resendLoading}
                    >
                      {resendLoading ? "Resending..." : "Resend OTP"}
                    </button>
                     {/* Skip Button */}
    <button
      type="button"
      onClick={onSkip}
      className="mt-6 text-sm text-gray-400 hover:text-secondary transition"
    >
      Skip for now
    </button>
                  </div>
                  </form>
                )
        : (
          <>
            {/* Login Form */}
            {formType === "login" && (
              <form onSubmit={handleSubmit(onSubmit)} className="bg-transparent p-0 rounded text-white">
                <h1 className="mb-6 text-2xl font-bold text-white">Login</h1>
                <AuthInput label="Email" errors={errors} register={register} type="email" name="email" id="email" placeholder="Email" />
                <AuthInput label="Password" errors={errors} register={register} type="password" name="password" id="password" placeholder="Password" />
                <button
                  type="submit"
                  className="uppercase w-full mt-4 p-3 rounded-md bg-secondary hover:bg-secondary/75 text-white"
                >
                  Sign In
                </button>
              </form>
            )}

            {/* Signup Form */}
            {formType === "signup" && (
              <form onSubmit={signupHandleSubmit(onSignup)} className="bg-transparent p-0 rounded text-white">
                <h1 className="mb-6 text-2xl font-bold text-white">Sign Up</h1>
                <AuthInput label="Name" errors={signupErrors} register={signupRegister} type="text" name="name" id="name" placeholder="Enter your name" />
                <AuthInput label="Email" errors={signupErrors} register={signupRegister} type="email" name="email" id="email" placeholder="Email" />
                <AuthInput label="Password" errors={signupErrors} register={signupRegister} type="password" name="password" id="password" placeholder="Password" />
                <AuthInput label="Confirm Password" errors={signupErrors} register={signupRegister} type="password" name="password_confirmation" id="cpassword" placeholder="Confirm Password" />
                <button
                  type="submit"
                  className="uppercase w-full mt-4 p-3 rounded-md bg-secondary hover:bg-secondary/75 text-white"
                >
                  Sign Up
                </button>
              </form>
            )}
          </>
        )}

        <button onClick={onClose} className="mt-4 text-gray-400 hover:text-white w-full transition">Close</button>
      </div>
    </div>
  );
} 